export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const dt = (s) => (s ? new Date(s).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-");
export const dOnly = (s) => (s ? new Date(s.length === 10 ? s + "T12:00:00" : s).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" }) : "-");
export const digits = (s) => (s || "").replace(/\D/g, "");

export const maskCpf = (v) => digits(v).slice(0, 11).replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
export const maskPhone = (v) => {
  const d = digits(v).slice(0, 11);
  return d.length > 10 ? d.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3") : d.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").replace(/-$/, "");
};
export const maskCep = (v) => digits(v).slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");

export function validCpf(cpf) {
  const d = digits(cpf);
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  for (const i of [9, 10]) {
    let s = 0;
    for (let j = 0; j < i; j++) s += Number(d[j]) * (i + 1 - j);
    if (((s * 10) % 11) % 10 !== Number(d[i])) return false;
  }
  return true;
}

export async function viaCep(cep) {
  const d = digits(cep);
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    const j = await r.json();
    return j.erro ? null : { rua: j.logradouro, bairro: j.bairro, cidade: j.localidade, uf: j.uf };
  } catch {
    return null;
  }
}

export const waLink = (phone, text) => `https://wa.me/${phone}?text=${encodeURIComponent(text || "")}`;

export const STATUS = {
  aguardando_pagamento: { label: "Aguardando pagamento", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  pago: { label: "Pago", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  em_separacao: { label: "Em separação", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  enviado: { label: "Enviado", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  entregue: { label: "Entregue", cls: "bg-na-sage text-na-forest border-na-line" },
  cancelado: { label: "Cancelado", cls: "bg-stone-100 text-stone-600 border-stone-200" },
  reembolsado: { label: "Reembolsado", cls: "bg-na-acai2 text-na-acai border-na-acai/20" },
};
export const PAY = { pix: "Pix", cartao: "Cartão", boleto: "Boleto" };

export function track(event, params = {}) {
  try {
    window.gtag?.("event", event, params);
    const map = { view_item: "ViewContent", add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout", add_payment_info: "AddPaymentInfo", purchase: "Purchase" };
    if (map[event]) window.fbq?.("track", map[event], { value: params.value, currency: "BRL" });
  } catch (e) {}
}

export const parseSacola = (s) =>
  (s || "")
    .split(",")
    .map((p) => p.trim().match(/^(.+)-(\d)-(\d+)$/))
    .filter(Boolean)
    .map((m) => ({ slug: m[1], frascos: Math.min(3, Math.max(1, Number(m[2]))), quantidade: Math.min(20, Math.max(1, Number(m[3]))), assinatura: false }));
export const buildSacola = (items) => items.map((i) => `${i.slug}-${i.frascos}-${i.quantidade}`).join(",");

export function useSeo(title, description) {
  if (typeof document !== "undefined") {
    document.title = title ? `${title} | Nativa Amazon` : "Nativa Amazon | Produtos naturais";
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement("meta");
      m.name = "description";
      document.head.appendChild(m);
    }
    if (description) m.content = description;
  }
}

export const SUPP_PHRASES = ["Este produto não é um medicamento.", "Não exceder a recomendação diária de consumo indicada na embalagem.", "Mantenha fora do alcance de crianças."];
export const MED_NOTICE = "Este produto não substitui orientação médica. Em caso de doença, procure um profissional de saúde.";
